// cSpell:ignore eigenaarsdeel Leegstand Samenvatting Toon
// How many costs a summary card lists before it folds the rest away (N10,
// retest of 2026-10-19). A building of 35 units with 320 costs gave every
// one of its 40 cards 320 rows: the Samenvatting froze 14 s and its Detail
// tab 8.5 s on 362.803 elements. A card of a smaller building lists every
// cost as before.
export const MAX_VISIBLE_CARD_COSTS = 25;

// The rows a card's section shows: its first `limit` costs, each with the
// rows of its causes (an owner's "Vast eigenaarsdeel" and "Leegstand" under
// the cost they explain), and how many costs it folded away. All of them
// once the broker unfolds the card.
export const visibleCardRows = <Row extends { layout?: string }>(params: {
  rows: Row[];
  isExpanded: boolean;
  limit?: number;
}): { rows: Row[]; hiddenCount: number } => {
  const { rows, isExpanded, limit = MAX_VISIBLE_CARD_COSTS } = params;
  if (isExpanded) return { rows, hiddenCount: 0 };
  let costs = 0;
  let cut = rows.length;
  rows.forEach((row, index) => {
    if (row.layout === "cause" || cut < rows.length) return;
    costs += 1;
    if (costs > limit) cut = index;
  });
  const hiddenCount = rows
    .slice(cut)
    .filter(row => row.layout !== "cause").length;
  return { rows: rows.slice(0, cut), hiddenCount };
};

// Whether an unfolded card's section offers "Toon minder" (M36, retest of
// 2026-10-20): only one that folded costs away before, so a short card never
// shows it.
export const isFoldable = (params: {
  rows: { layout?: string }[];
  isExpanded: boolean;
  limit?: number;
}): boolean => {
  const { rows, isExpanded, limit = MAX_VISIBLE_CARD_COSTS } = params;
  return (
    isExpanded && rows.filter(row => row.layout !== "cause").length > limit
  );
};
